import React, { Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@/components/theme-provider";
import { Toaster } from "@/components/ui/sonner";

// Lazy load pages for performance optimization
const HomePage = lazy(() => import("@/pages/HomePage"));
const PortfolioPage = lazy(() => import("@/pages/PortfolioPage"));
const ProcessDetailPage = lazy(() => import("@/pages/ProcessDetailPage"));
const TestimonialsPage = lazy(() => import("@/pages/TestimonialsPage"));


// import CustomCursor from "@/components/CustomCursor";
import ScrollToTop from "@/components/ScrollToTop";
import ScrollToTopButton from "@/components/ScrollToTopButton";

function App() {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Suspense fallback={
            <div className="min-h-screen bg-black flex items-center justify-center">
              <div className="w-8 h-8 border-2 border-orange-500 border-t-transparent rounded-full animate-spin"></div>
            </div>
          }>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/portfolio" element={<PortfolioPage />} />
              <Route path="/process/:id" element={<ProcessDetailPage />} />
              <Route path="/testimonials" element={<TestimonialsPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
        {/* <CustomCursor /> */}
        <Toaster />
        <ScrollToTopButton />
      </div>
    </ThemeProvider>
  );
}

export default App;
